import { render, staticRenderFns } from "./clusterNum.vue?vue&type=template&id=9f973404&scoped=true&"
import script from "./clusterNum.vue?vue&type=script&lang=js&"
export * from "./clusterNum.vue?vue&type=script&lang=js&"
import style0 from "./clusterNum.vue?vue&type=style&index=0&id=9f973404&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f973404",
  null
  
)

export default component.exports